<template>
  <v-layout  row fill-height class="list-item" :class="{ 'selected': selected }" @click="handleClick()">
    <v-flex shrink class="selection-border"></v-flex>
    <v-flex grow class="item-content">
      <slot></slot>
    </v-flex>
    <v-flex shrink class="select-button">
      <v-layout align-center justify-start row fill-height>
        <div class="arrow-right"></div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'ListItem',
  props: {
    selected: Boolean
  },
  methods: {
    handleClick () {
      this.$emit('handle-click')
    }
  }
}
</script>

<style lang="scss" scoped>

.list-item{
  background-color: #fafafa;
  margin-top: 3px;
  &:first-child{
    margin-top: 0px;
  }
  height: auto;
  &.selected{
    border: 1px solid #378e07;
    .selection-border {
      background: #378e07;
    }
    .arrow-right{
      border-left: 5px solid white;
    }
    .select-button{
      background: #378e07;
    }
  }
}

.selection-border{
  width: 8px;
  background: white;
}

.select-button{
  width: 46px;
}

.item-content{
  padding: 0px 45px 0px 15px;
}

.arrow-right {
  width: 0;
  height: 0;
  margin-left: 10px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;

  border-left: 5px solid black;
}

</style>
